import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMyOffice = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-my-office';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 12v8.76h17.52V3.24H3.24zm16 0v7.24H4.76V4.76h14.48zm-8.235-4.538c-1.682.294-2.951 1.459-3.425 3.146l-.064.228-.228.065c-.692.2-1.345.736-1.659 1.359-.402.801-.385 1.987.041 2.86.207.425.785 1.003 1.21 1.21.622.303.382.286 4.226.3l3.446.013 2.054-2.107 2.054-2.106-.005-.265c-.025-1.333-1.086-2.39-2.633-2.623-.394-.059-.382-.051-.622-.445-.195-.32-.684-.812-1.031-1.035a3.8 3.8 0 0 0-1.192-.528c-.342-.09-.496-.106-1.117-.117-.506-.01-.819.004-1.055.045m1.396 1.459c.61.075 1.05.265 1.42.615l.233.221-.237.124a3.45 3.45 0 0 0-1.795 2.451c-.083.482-.01 1.212.179 1.788.082.248.363.844.448.95.033.04-.444.05-2.357.05-2.725 0-2.622.011-2.987-.323a1.4 1.4 0 0 1-.328-.445c-.105-.23-.115-.292-.116-.712-.001-.424.008-.478.111-.688.129-.264.279-.403.588-.548.196-.092.279-.105.77-.117.479-.013.55-.023.55-.081.002-.264.093-1.019.146-1.202.43-1.497 1.709-2.286 3.375-2.083m3.799 2.195a2.4 2.4 0 0 1 .452.216c.194.13.44.443.419.536-.011.052-2.752 2.892-2.79 2.891-.054-.001-.349-.455-.507-.779-.278-.573-.355-1.088-.233-1.559.162-.62.636-1.122 1.278-1.351.286-.103 1.016-.078 1.381.046"
    })
  }));
});
export default SvgMyOffice;